import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class FootprintManager_ds_return_serial_numbers_selector_gridService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { ownerId?: number, projectId?: number, warehouseId?: number, orderId?: number, lotId?: number, vendorLotId?: number, materialId?: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, LicensePlate?: { LookupCode?: string, Shipment?: { LookupCode?: string } }, Lot?: { LookupCode?: string, Material?: { LookupCode?: string, Project?: { LookupCode?: string, Owner?: { LookupCode?: string } } }, VendorLot?: { LookupCode?: string } } }[] }> 
  {
    let url = `${environment.backendUrl}api/FootprintManager/datasources/ds_return_serial_numbers_selector_grid/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { ownerId?: number, projectId?: number, warehouseId?: number, orderId?: number, lotId?: number, vendorLotId?: number, materialId?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, LicensePlate?: { LookupCode?: string, Shipment?: { LookupCode?: string } }, Lot?: { LookupCode?: string, Material?: { LookupCode?: string, Project?: { LookupCode?: string, Owner?: { LookupCode?: string } } }, VendorLot?: { LookupCode?: string } } }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/FootprintManager/datasources/ds_return_serial_numbers_selector_grid/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { ownerId?: number, projectId?: number, warehouseId?: number, orderId?: number, lotId?: number, vendorLotId?: number, materialId?: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, LookupCode?: string, LicensePlate?: { LookupCode?: string, Shipment?: { LookupCode?: string } }, Lot?: { LookupCode?: string, Material?: { LookupCode?: string, Project?: { LookupCode?: string, Owner?: { LookupCode?: string } } }, VendorLot?: { LookupCode?: string } } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/FootprintManager/datasources/ds_return_serial_numbers_selector_grid/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      ownerId?: number, projectId?: number, warehouseId?: number, orderId?: number, lotId?: number, vendorLotId?: number, materialId?: number    }) {
      return false;
    }
}
